import { Navigate } from 'react-router-dom';
import { BROWSER_ROUTES } from '@constants/browser.routes';
import { useSelector } from 'react-redux';
import type { FC, ReactNode } from 'react';
import type { RootState } from '../../store/store';

interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated } = useSelector((state: RootState) => state.user);
  if (isAuthenticated) {
    return <Navigate to={BROWSER_ROUTES.DASHBOARD} replace />;
  }
  return <>{children}</>;
};

export default GuestGuard; 